import { createReducer } from '@reduxjs/toolkit'

import { TDashboardFilterOption } from 'types/GlobalDashboardFilter'

import * as actions from 'redux/actions/ResourceFilter/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface ResourceFilterReducerType {
  options: TDashboardFilterOption[]
  data: { [attributeId: string]: string[] | undefined }
  fetched: boolean
  fetching: boolean
}

const INITIAL_STATE: ResourceFilterReducerType = {
  options: [],
  data: {},
  fetched: false,
  fetching: false
}

const resourceFilterReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetching = true
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      const { payload } = action

      state.options = payload
      state.fetched = true
      state.fetching = false
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetching = false
    })
    .addCase(actions.getData, (state, action) => {
      const { payload } = action

      payload.forEach((key) => {
        state.data[key] = undefined
      })
    })
    .addCase(actions.getDataSuccess, (state, action) => {
      const { payload } = action

      payload.forEach((item) => {
        state.data[item.attributeId] = item.options
      })
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default resourceFilterReducer
